import portalApi from './axios/portalAxios';

export const loginRequest = (data) => {
  return portalApi.post('/login', data);
};

export const registerRequest = (data) => {
  return portalApi.post('/register', data);
};

export const logoutRequest = () => {
  return portalApi.post('/logout');
};

export const refreshTokenRequest = (refreshToken) => {
  return portalApi.post('/auth/refresh', { refresh_token: refreshToken });
};

// OTP / Email verification
export const verifyEmailRequest = (data) => {
  return portalApi.post('/verify-email', data);
};
export const resendOtpRequest = (data) => {
  return portalApi.post('/resend-otp', data);
};

// Forgot / Reset password
export const forgotPasswordRequest = (data) => {
  return portalApi.post('/forgot-password', data);
};
export const resetPasswordRequest = (data) => {
  return portalApi.post('/reset-password', data);
};

// Account (authenticated)
export const changePasswordRequest = (data) => {
  return portalApi.post('/account/change-password', data);
};
export const changeEmailRequest = (data) => {
  return portalApi.post('/account/change-email', data);
};
export const confirmEmailChangeRequest = (data) => {
  return portalApi.post('/account/change-email/confirm', data);
};
